import { z } from 'zod';

const SearchSelectionSchema = z
  .object({
    value: z.string(),
    label: z.string(),
  })
  .nullish();

export const UserInvitationFormSchema = z.object({
  firstName: z
    .string()
    .trim()
    .min(1, { message: 'กรุณากรอกชื่อภาษาอังกฤษ' })
    .regex(/^[a-zA-Z\s()]*$/i, {
      message: 'กรุณากรอกชื่อเป็นภาษาอังกฤษเท่านั้น',
    }),
  lastName: z
    .string()
    .trim()
    .min(1, { message: 'กรุณากรอกนามสกุลภาษาอังกฤษ' })
    .regex(/^[a-zA-Z\s()]*$/i, {
      message: 'กรุณากรอกนามสกุลเป็นภาษาอังกฤษเท่านั้น',
    }),
  email: z
    .string()
    .trim()
    .min(1, { message: 'กรุณากรอกอีเมล' })
    .email({
      message: 'กรุณากรอกอีเมลให้ถูกต้อง',
    })
    .regex(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/, {
      message: 'กรุณากรอกอีเมลให้ถูกต้อง',
    }),
  appRoles: z.array(SearchSelectionSchema),
});

export type UserInvitationFormInput = z.infer<typeof UserInvitationFormSchema>;
